<template>
    <lottie-player
        :src="loader"
        background="transparent"
        speed="1"
        loop
        autoplay
        :class="sizes[size] ?? sizes.xl"
    ></lottie-player>
</template>

<script setup lang="ts">
const sizes = {
    xs: 'w-8 h-8',
    s: 'w-12 h-12',
    m: 'w-16 h-16',
    l: 'w-24 h-24',
    xl: 'w-28 h-28',
    '2xl': 'w-32 h-32',
    '3xl': 'w-48 h-48',
    '4xl': 'w-52 h-52',
} as const;

type Size = keyof typeof sizes;

defineProps({
    loader: {
        type: String,
        required: false,
        default: '/moveprologo.json',
    },
    size: {
        type: String as PropType<Size>,
        required: false,
        default: 'xl',
    },
});
</script>
